import React, { useRef } from "react";
import { Carousel } from "primereact/carousel";
import styles from "./mobile-related-properties.module.scss";
import { MobileRelatedPropertiesProps } from "./mobile-related-properties.interface";
import { useRelatedProperties } from "../../../../hooks/react-query/properties/useRelatedProperty";
// import MobilePropertyListCard from "../mobile-property-list-card";
import MobilePropertiesCard from "../../mobile-properties-card";
import { StatusObjectColorFilter } from "../../../../utils/utils";
// import { relatedPropertyList } from "./RelatedPropertyData";
const MobileRelatedProperties = ({
  title,
  // currencyCode,
  // locale,
  propertyId
}: MobileRelatedPropertiesProps) => {
  const { data: relatedPropertyList, refetch } =
    useRelatedProperties(propertyId);
  const carouselRef: any = useRef<Carousel>(null);

  // const relatedPropertyList:any= useMemo(() => {
  //   return _relatedPropertyList ? _relatedPropertyList.slice(0, 5) : [];
  // }, [_relatedPropertyList]);

  const responsiveOptions = [
    {
      breakpoint: "1450px",
      numVisible: 3,
      numScroll: 1
    },
    {
      breakpoint: "1199px",
      numVisible: 3,
      numScroll: 1
    },
    {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1
    }
  ];
  refetch();
  const productTemplate = (property: any) => {
    return (
      <MobilePropertiesCard
        refetch={refetch}
        item={property}
        status={StatusObjectColorFilter(property?.status)}
        loginType={"agent"}
        // imageUrl={property.posterImage}
        // shape={"circle"}
        // listedTitle={"Listed By"}
        // defaultProfile={property?.acquisitionAgent1?.bannerPhotoUrl}
        // agentFirstName={property?.acquisitionAgent1?.name?.split(" ")[0]}
        // agentLastName={property?.acquisitionAgent1?.name?.split(" ")[1]}
        // salesInstruction={property?.salesInstruction}
        // address={property?.address}
        // location={property?.location}
        // amount={property.askingPrice}
        // currencyCode={currencyCode}
        // locale={locale}
        // propertyId={property?.id}
        // park={property?.park}
        // property={property}
        // city={property?.city}
        // state={property?.state}
        // postalCode={property?.postalCode}
        // favCount={property?.favCount}
      />
    );
  };

  return (
    <div className={styles.relatedProperties}>
      {relatedPropertyList && relatedPropertyList.length > 0 && (
        <>
          <div className={styles.title}>{title}</div>
          <Carousel
            value={relatedPropertyList}
            ref={carouselRef}
            numVisible={4}
            numScroll={1}
            responsiveOptions={responsiveOptions}
            itemTemplate={productTemplate}
            showIndicators={false}
            showNavigators={true}
          />
        </>
      )}
    </div>
  );
};
export default React.memo(MobileRelatedProperties);
